<section class="row no-gutters">
  <div class="mobile-overlay d-md-none" [ngClass]="{'show': openMobileMenu}" (click)="closeMobileMenu()"></div>
  <div class="col-md-2 main-sidebar" *ngIf="sidebar">
    <xform-sidebar></xform-sidebar>
  </div>
  <div class="col" [ngClass]="{'col-12': !sidebar, 'col-12 col-md-10': sidebar}" [class]="bgColor">
    <ng-content></ng-content>
  </div>
</section>
